import { Theme, ThemeAllDetails } from './../models/theme.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LoggingService } from '../../services/logging.service';
import { LocalCacheManager } from '../managers/local-cache.manager';
import { DeviceGroup } from '../models/device-group.model';
import { ThemeSchedules } from '../models/theme-schedules.model';
import { ThemeStatus } from '../models/theme-status.model';
import { ApiUrlService } from './api-url.service';
import { ApiService } from './api.service';
import { MessageService } from 'primeng/primeng';

@Injectable()
export class ThemeApiService extends ApiService {
    constructor(protected http: HttpClient, private messageService: MessageService, protected apiUrlService: ApiUrlService, protected localCacheManager: LocalCacheManager) {
        super(http, localCacheManager);
    }

    getThemeStatuses(locationId: number): Observable<ThemeStatus[]> {
        return this.apiRequest(this.apiUrlService.getThemeStatusUrl(locationId), this.HttpMethod.Get);
    }

    getThemeSchedules(themeId: number): Observable<ThemeSchedules> {
        return this.apiRequest(this.apiUrlService.getThemeSchedulesUrl(themeId), this.HttpMethod.Get);
    }

    forceThemeOn(themeId: number, duration: number): Observable<boolean> {
        return this.apiRequest(this.apiUrlService.getForceThemeOnUrl(themeId, duration), this.HttpMethod.Put)
            .pipe(
                map((response: any) => {
                    return response['WasSuccess'];
                }),
                catchError((error: any) => {
                    LoggingService.log(error);
                    // this.messageService.add({ severity: 'error', summary: 'Error', detail: error['error']['Message'] });
                    // return of(false);
                    throw error;
                })
            );
    }

    forceThemeOff(themeId: number): Observable<boolean> {
        return this.apiRequest(this.apiUrlService.getForceThemeOffUrl(themeId), this.HttpMethod.Put)
            .pipe(
                map((response: any) => {
                    return response['WasSuccess'];
                }),
                catchError((error: any) => {
                    // this.messageService.add({ severity: 'error', summary: 'Error', detail: error['error']['Message'] });
                    LoggingService.log(error);
                    throw error;
                    // return of(false);
                })
            );
    }

    forceAllThemesOn(locationId: number): Observable<boolean> {
        return this.apiRequest(this.apiUrlService.getForceAllThemesOnUrl(locationId), this.HttpMethod.Put)
            .pipe(
                map((response: any) => {
                    return response['WasSuccess'];
                }),
                catchError((error: any) => {
                    // this.messageService.add({ severity: 'error', summary: 'Error', detail: error['error']['Message'] });
                    LoggingService.log(error);
                    throw error;
                    // return of(false);
                })
            );
    }

    forceAllThemesOff(locationId: number): Observable<boolean> {
        return this.apiRequest(this.apiUrlService.getForceAllThemesOffUrl(locationId), this.HttpMethod.Put)
            .pipe(
                map((response: any) => {
                    return response['WasSuccess'];
                }),
                catchError((error: any) => {
                    LoggingService.log(error);
                    return of(false);
                })
            );
    }

    createTheme(locationId: number, createThemeModel: { Theme: Theme, Scenes: any[], LocationId: number, AccountId: number }): Observable<any> {
        return this.apiRequest(this.apiUrlService.getCreateThemeUrl(locationId), this.HttpMethod.Post, createThemeModel);
    }

    updateTheme(themeId: number, updateThemeModel: { Theme: Theme }): Observable<any> {
        return this.apiRequest(this.apiUrlService.getUpdateThemeUrl(themeId), this.HttpMethod.Post, updateThemeModel);
    }

    getThemes(locationId: number): Observable<any> {
        return this.apiRequest(this.apiUrlService.getThemesUrl(locationId), this.HttpMethod.Get);
    }

    deleteTheme(themeId: number): Observable<any> {
        return this.apiRequest(this.apiUrlService.getDeleteThemeUrl(themeId), this.HttpMethod.Post);
    }

    getThemeDetails(themeId: number): Observable<ThemeAllDetails> {
        return this.apiRequest(this.apiUrlService.getThemeDetailsUrl(themeId), this.HttpMethod.Get);
    }
}
